import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { toCamelCase } from "utils/Utils";

const PersonalInfoReview = ({ classes, generalDetails, documentDetails, userLeadIdDetails, photoDetails }) => {
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      {/* General Details Title - Full Width */}
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          General Details
        </h2>
      </Grid>

      {/* Photo on Left & Data on Right */}
      <Grid item xs={12} container spacing={2} alignItems="center">
        {/* Customer Photo - Left */}
        <Grid item xs={12} sm={4} md={3}>
        <p style={{ marginBottom: 0 }}>
          <b>{'Customer Photo'}</b>
        </p>
          <img
            src={documentDetails?.customerPhotoLink || ""}
            alt="Customer"
            style={{
              width: "100%",
              maxWidth: "150px",
              height: "auto",
              borderRadius: "8px",
              objectFit: "cover",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
        <p style={{ marginBottom: 0 }}>
          <b>{'Pan Photo'}</b>
        </p>
          <img
            src={documentDetails?.pancardLink || ""}
            alt="PanCard"
            style={{
              width: "100%",
              maxWidth: "150px",
              height: "auto",
              borderRadius: "8px",
              objectFit: "cover",
            }}
          />
        </Grid>

        {/* Data on Right of Photo */}
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
            {itemView("Photo Matched", photoDetails?.confidence || "0")}
            {itemView("Name", userLeadIdDetails?.customer_name || "NA")}
            {itemView("Marital Status", toCamelCase(generalDetails?.maritalStatus) || "NA")}
            {itemView("Education", generalDetails?.education || "NA")}
            {itemView("Occupation", generalDetails?.occupation || "NA")}
            {itemView("E-mail", generalDetails?.email || "NA")}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

PersonalInfoReview.propTypes = {
  classes: PropTypes.object,
  generalDetails: PropTypes.object,
  documentDetails: PropTypes.object,
};

export default PersonalInfoReview;
